import type {
  IAdminLeasingProduct,
  IAdminLeasingProductCar,
  IAdminLeasingProductCondition,
  IAdminLeasingProductItem,
  ICreateAdminLeasingProduct,
  ICreateLeasingProductCondition,
  IGetAdminLeasingProductsParams,
  TUpdateAdminLeasingProduct
} from '@/AdminPanel/pages/Products/types/product.api-types';
import { ApiConnector } from '@/api/api.connector';

class ProductsApi extends ApiConnector {
  getAdminProducts(params: IGetAdminLeasingProductsParams): Promise<{
    total: number;
    data: IAdminLeasingProductItem[];
  }> {
    return this.call({
      path: 'admin/leasing-products',
      params
    });
  }

  getAdminProductById(productId: string): Promise<IAdminLeasingProduct> {
    return this.call({ path: `admin/leasing-products/${productId}` });
  }

  createAdminProduct(
    product: ICreateAdminLeasingProduct
  ): Promise<IAdminLeasingProduct> {
    return this.call({
      path: 'admin/leasing-products',
      method: 'post',
      body: product
    });
  }

  updateAdminProduct(productId: string, data: TUpdateAdminLeasingProduct) {
    return this.call({
      path: `admin/leasing-products/${productId}`,
      method: 'patch',
      body: data
    });
  }

  deleteAdminProduct(productId: string) {
    return this.call({
      path: `admin/leasing-products/${productId}`,
      method: 'delete'
    });
  }

  // --- Leasing Product Conditions ---

  getProductConditions(productId: string): Promise<{
    total: number;
    data: IAdminLeasingProductCondition[];
  }> {
    return this.call({
      path: `admin/leasing-products/${productId}/conditions`,
      params: {
        limit: 100,
        page: 1
      }
    });
  }

  createProductCondition(
    productId: string,
    condition: ICreateLeasingProductCondition
  ) {
    return this.call({
      path: `admin/leasing-products/${productId}/conditions`,
      method: 'post',
      body: condition
    });
  }

  updateProductCondition(
    productId: string,
    conditionId: string,
    condition: ICreateLeasingProductCondition
  ) {
    return this.call({
      path: `admin/leasing-products/${productId}/conditions/${conditionId}`,
      method: 'patch',
      body: condition
    });
  }

  deleteProductCondition(productId: string, conditionId: string) {
    return this.call({
      path: `admin/leasing-products/${productId}/conditions/${conditionId}`,
      method: 'delete'
    });
  }

  // --- Leasing Product Cars ---

  getProductCars(productId: string): Promise<{
    total: number;
    data: IAdminLeasingProductCar[];
  }> {
    return this.call({
      path: `admin/leasing-products/${productId}/cars`,
      params: {
        limit: 100,
        page: 1
      }
    });
  }

  createProductCar(productId: string, body: { modelIds: string[] }) {
    return this.call({
      path: `admin/leasing-products/${productId}/cars`,
      method: 'post',
      body
    });
  }

  deleteProductCar(productId: string, modelId: string) {
    return this.call({
      path: `admin/leasing-products/${productId}/cars/${modelId}`,
      method: 'delete'
    });
  }
}

export const productsApi = new ProductsApi();
